<template>
  <div>
    <p>
      The user may define payload telecom properties, which are used to simulate
      data storage in the constellation simulation mission. For this, an
      <b>uplink rate</b> must be set, representing the maximum data rate from
      the payload to a ground station.
    </p>
    <p>
      <i>Nota bene:</i> in order to simulate data storage, the user must also
      define a <b>link budget</b> in the constellation simulation mission
      configuration, to represent the data acquisition by the spacecraft.
    </p>
  </div>
</template>

<script>
export default {
  name: 'tooltipPayloadTelecom'
}
</script>
